import { ICommand, IDatasource, IDefineCommand, IQuery, key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APCourse } from '../../../builders/ap_course_builder';
import { IAPCoursesDatasource } from '../../../datasources/ap_courses_datasource';
import { APCourseInfoModel } from '../models/course_info_model';

interface IFavoriteItemAPI {
  id: number;
}

angular
  .module('capability-ng-academic-planner')
  .factory(
    'saveFavoriteCourseCommand',
    function saveFavoriteCourseCommandDefinition(
      log: any,
      $http: ng.IHttpService,
      ngAPCoursesDatasource: IAPCoursesDatasource,
      ngAPCourseInfoModel: APCourseInfoModel,
      defineCommandORM: IDefineCommand
    ): ICommand {
      return defineCommandORM(
        'saveFavoriteCourseCommand',
        function saveFavoriteCourseCommand(deferred: ng.IDeferred<any>, course: APCourse): void {
          $http
            .post('favorite/favoriteitem/', {
              content_type: 'cat.course',
              object_id: course.id
            })
            .then((response: { data: IFavoriteItemAPI }) => {
              course.is_favorite = true;
              course.favorite_id = response.data.id;
              ngAPCoursesDatasource.put(course);
              ngAPCourseInfoModel.write({
                course: {
                  [course.id]: course
                }
              });
              deferred.resolve(course);
            })
            .catch((e) => {
              log.issue('failed to save course as favorite');
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_detail/commands/save_favorite_course_command.ts